
/* eslint-disable max-len */
const Hourglass = () => (
  <svg id="Art" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2">
    <path d="M9.5,14.5l-5.08,5.08c-.89.89-.26,2.42,1,2.42h13.17c1.26,0,1.89-1.53,1-2.42L4.42,4.42c-.89-.89-.26-2.42,1-2.42h13.17c1.26,0,1.89,1.53,1,2.42l-5.08,5.08" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default Hourglass;
